module.exports = __webpack_public_path__ + "img/html-evolution-17.b50d8c80.jpg";